import cn from 'classnames'
import { Button } from '@components/Buttons'
import { BookCollection } from '@features/myReading/components/BookCollection'
import { BookCollectionPrivacyEnum } from '@interfaces/BookCollectionPrivacyEnum'
import { Loading } from '@components/Loading'
import { BookCollectionListProps } from './interface'

const privacyOptions = [
  { value: null, label: 'ทั้งหมด' },
  { value: BookCollectionPrivacyEnum.PUBLIC, label: 'สาธารณะ' },
  { value: BookCollectionPrivacyEnum.PRIVATE, label: 'เฉพาะฉัน' },
]

export function BookCollectionList({
  privacyType,
  isLoading,
  bookCollections,
  handlePrivacyTypeChange,
  handleCreateBookCollection,
  handleEditBookCollection,
  handleDeleteBookCollection,
  handleGoToBookCollectionDetail,
}: BookCollectionListProps) {
  return (
    <>
      <div className='relative flex text-[14px] text-secondary-1'>
        {privacyOptions.map((item, i) => (
          <button
            key={i}
            onClick={() => handlePrivacyTypeChange(item.value)}
            className={cn('flex py-[10px] px-[20px]  font-light z-10', {
              'border-b-[3px] border-secondary dark:border-dark-10 font-bold text-secondary dark:text-dark-10':
                privacyType === item.value,
            })}
          >
            {item.label}
          </button>
        ))}
        <div className='absolute w-full h-[1px] bottom-[1px] bg-gray dark:bg-purple z-0' />
      </div>
      {isLoading ? (
        <div className='flex justify-center mt-[20px]'>
          <Loading />
        </div>
      ) : bookCollections.length > 0 ? (
        <div className='items-start grid grid-cols-4 tablet:grid-cols-2 mobile:grid-cols-1 justify-items-center gap-x-[20px] gap-y-[30px] mt-[20px]'>
          <div className='flex border border-dashed justify-center border-gray-3 dark:border-purple py-[55px] text-center rounded-[8px] mobile:py-[30px] w-full tablet-mobile:w-[348px]'>
            <Button
              data-test='create-book-list-button'
              className='bg-primary dark:bg-purple text-white dark:text-white-2 text-[14px] px-[30px]'
              type='button'
              onClick={handleCreateBookCollection}
            >
              สร้างลิสต์
            </Button>
          </div>
          {bookCollections.map(collection => (
            <BookCollection
              dataTest={`collection-${collection.collectionName}`}
              key={collection.id}
              collectionName={collection.collectionName}
              privacyType={collection.privacyType}
              books={collection.books}
              canEdit
              canDelete
              goToBookCollectionDetail={() =>
                handleGoToBookCollectionDetail(collection.id)
              }
              onEdit={() => handleEditBookCollection(collection)}
              onDelete={() =>
                handleDeleteBookCollection(
                  collection.id,
                  collection.collectionName
                )
              }
            />
          ))}
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center py-[60px]'>
          <p
            data-test='data-not-found'
            className='font-mitr font-medium text-[24px] text-secondary-1 dark:text-dark-10 mb-[20px]'
          >
            ไม่พบลิสต์หนังสือ
          </p>
          <Button
            data-test='create-book-list-button'
            className='bg-primary dark:bg-purple text-white dark:text-white-2 text-[14px] font-medium px-[30px]'
            type='button'
            onClick={handleCreateBookCollection}
          >
            สร้างลิสต์
          </Button>
        </div>
      )}
    </>
  )
}
